import { render, staticRenderFns } from "./PipiPupuFile.vue?vue&type=template&id=1fd36f17"
import script from "./PipiPupuFile.vue?vue&type=script&lang=js"
export * from "./PipiPupuFile.vue?vue&type=script&lang=js"
import style0 from "./PipiPupuFile.vue?vue&type=style&index=0&id=1fd36f17&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports